/**
 * WorkshopsCalendarDowHeader — the day-of-week header row above the
 * WorkshopsCalendarGrid body (Sun…Sat, or rotated per `weekStartsOn`).
 */
export function WorkshopsCalendarDowHeader({ labels }: { labels: string[] }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        borderBottom: '1px solid var(--nb-border)',
      }}
    >
      {labels.map((d, i) => (
        <div
          key={i}
          style={{
            padding: '8px 6px',
            fontSize: 9.5,
            fontWeight: 700,
            letterSpacing: '.08em',
            color: 'var(--nb-subtle)',
            textAlign: 'center',
            borderLeft: i === 0 ? 'none' : '1px solid var(--nb-border)',
          }}
        >
          {d}
        </div>
      ))}
    </div>
  );
}
